import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Table } from "antd";
import { FaTableList, FaCalendarDays, FaBookOpen } from "react-icons/fa6";

import styles from "./TabelaAluno.module.scss";

const gerarColunas = () => [
    {
        title: "Campo",
        dataIndex: "label",
        key: "label",
        width: "40%",
        render: text => <strong>{text}</strong>
    },
    {
        title: "Valor",
        dataIndex: "valor",
        key: "valor",
        width: "60%",
        render: text => <span>{text}</span>
    }
];

const transformarDataSource = (row, columns, entidade) => {
    const data = columns
        .filter(col => col.key !== "turma") // Ignorar a coluna onde estarão os botões
        .map(col => ({
            key: col.key,
            label: col.header,
            valor: row[col.key]
        }));

    data.push({
        key: "acoes",
        label: "Ações",
        valor: (
            <div className={styles.acoesMobile}>
                <Link to={`/${entidade}/area-aluno/relatorio/${row.code}`} className={`${styles.botao} ${styles.botaoNotas}`}>
                    <span>
                        {/* <Icon type="table" /> */}
                        <FaTableList />
                    </span>
                    <span className={styles.texto}>Notas</span>
                </Link>

                <Link to={`/${entidade}/area-aluno/calendario/${row.code}`} className={`${styles.botao} ${styles.botaoHorario} ${styles.botaoMobile}`}>
                    <span>
                        {/* <FaTableList /> */}
                        <FaCalendarDays />
                    </span>
                    <span className={styles.texto}>Horário</span>
                </Link>

                <Link
                    to={`/${entidade}/area-aluno/conteudos/${row.code}`}
                    className={`${styles.botao} ${styles.botaoConteudos} ${styles.botaoMobile}`}
                    onClick={() => localStorage.removeItem("codigo_curso")}
                >
                    <span>
                        <FaBookOpen />
                    </span>
                    <span className={styles.texto}>CONTEÚDOS</span>
                </Link>
            </div>
        )
    });

    return data;
};

const TabelaAluno = ({ columns, data }) => {
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const entidade = pathParts[1];

    const tableColumns = gerarColunas();

    return (
        <div>
            {data.map((row, index) => (
                <div key={index}>
                    <Table
                        columns={tableColumns}
                        className={styles.tabela}
                        dataSource={transformarDataSource(row, columns, entidade)}
                        pagination={false}
                        showHeader={false}
                        bordered
                        size="small"
                        rowKey={record => `${index}-${record.key}`}
                    />
                </div>
            ))}
        </div>
    );
};

export default TabelaAluno;
